import { ANALYTIC_SOURCE_PARAM } from '@/libs/userSource/config';

// Setting the tracking cookies for 30 days as it's a common attribution window used by advertising platforms.
export const TRACKING_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export type TrackingCookieConfig = {
  cookieName: 'ttclid' | 'aclid' | 'gclid';
  maxAgeSeconds: number;
  urlParamNames: readonly string[];
};

export const TRACKING_COOKIE_CONFIGS: TrackingCookieConfig[] = [
  {
    cookieName: 'ttclid',
    maxAgeSeconds: TRACKING_COOKIE_MAX_AGE_SECONDS,
    urlParamNames: [ANALYTIC_SOURCE_PARAM.Ttclid],
  },
  {
    cookieName: 'aclid',
    maxAgeSeconds: TRACKING_COOKIE_MAX_AGE_SECONDS,
    urlParamNames: [ANALYTIC_SOURCE_PARAM.Aclid],
  },
  {
    cookieName: 'gclid',
    maxAgeSeconds: TRACKING_COOKIE_MAX_AGE_SECONDS,
    urlParamNames: [ANALYTIC_SOURCE_PARAM.Gclid],
  },
];
